import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { applicationsKeys } from "./utils";

/**
 * Disconnect a single Application
 * @param applicationId application id
 * @param options useMutation options
 * @returns useMutation result
 */
export const useApplicationDisconnect = (
  applicationId: string,
  options?: UseMutationOptions<void, PortalAxiosError, void>
) => {
  const queryClient = useQueryClient();
  const server = useServer();

  return useMutation<void, PortalAxiosError, void>(
    () => server.get(`applications/${applicationId}/disconnect`),
    {
      ...options,
      onSuccess: (application, variables, context) => {
        queryClient.invalidateQueries(applicationsKeys.getOne(applicationId));
        queryClient.invalidateQueries({
          queryKey: applicationsKeys.list(),
          exact: true,
        });

        options?.onSuccess?.(application, variables, context);
      },
    }
  );
};

export default useApplicationDisconnect;
